import { ObjectValues } from 'src/common/tsHelpers';

export const BADGE_STATUSES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  PENDING: 'pending',
  INACTIVE: 'inactive',
  UNKNOWN: 'unknown',
  TERMINATED: 'terminated',
} as const;

export const badgeStatusValues = Object.values(BADGE_STATUSES);

export type BadgeStatus = ObjectValues<typeof BADGE_STATUSES>;

export const BADGE_TYPE = {
  FILLED: 'filled',
  TEXT: 'text',
} as const;

export type BadgeType = ObjectValues<typeof BADGE_TYPE>;
